import { authActions } from '../../../actions/auth/auth'

/**
 * Check social media authentication status and process results
 * @param {string} assetId - Asset ID
 * @returns {Promise<Object>} Processed auth status
 */
export const checkSocialAuth = async (assetId) => {
  try {
    // Get auth status from API
    const authStatus = await authActions.checkSocialAuth(assetId)
    
    // Check if the result contains an error
    if (authStatus && authStatus.error) {
      return {}
    }
    
    // Check for empty/null response
    if (!authStatus) {
      return {}
    }
    
    // Return data with fallback to empty object
    return authStatus || {}
  } catch (error) {
    console.error('Error in checkSocialAuth service:', error)
    return {}
  }
}
